import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import Dropdown from 'react-bootstrap/Dropdown';
import DropdownToggle from 'react-bootstrap/DropdownToggle';
import DropdownMenu from 'react-bootstrap/DropdownMenu';
import DropdownItem from 'react-bootstrap/DropdownItem';
import { Field } from 'redux-form';
import { Link } from 'react-router';

import styles from './styles.module.css';

/**
 * Abstract component for wrapping questionnaire fields
 * Responsibilities:
 * - Rendering prompt, help text, links, comment form
 * - Managing comment state
 */
export class QuestionnaireItem extends Component {
  constructor(props) {
    super(props);

    this.state = { commenting: false };
  
    this.handleRevealClick = this.handleRevealClick.bind(this);
    this.renderLinks = this.renderLinks.bind(this);
    this.renderLink = this.renderLink.bind(this);
    this.renderLinkInMenuItem = this.renderLinkInMenuItem.bind(this);
    this.renderComment = this.renderComment.bind(this);
    this.renderCommentForm = this.renderCommentForm.bind(this);
  }

  /* Called when the reveal comment link is clicked */
  handleRevealClick(e) {
    e.preventDefault();
    this.setState({ ...this.state, commenting: true });
  }

  /* Format a single link */
  renderLink(link) {
    return <a href={link.url} rel="noopener" target="_blank" styleName="inline-link">{link.text}</a>;
  }

  renderLinkInMenuItem(link, index) {
    const {url, text} = link;
    return (
      <li role="presentation" key={url}>
        <DropdownItem as={Link} eventKey={index} href={url} target="_blank" to={url}>{text}</DropdownItem>
      </li>
    );
  }

  renderLinks() {
    const { links } = this.props;

    if (!links || links.length === 0) {
      return null;
    }

    if (links.length === 1) {
      return this.renderLink(links[0]);
    }
    
    return (
      <Dropdown className="btn-group">
        <DropdownToggle variant="default" id={`checklist-links-${this.props.name}`} styleName="inline-toggle">Learn more <span className="caret"/></DropdownToggle>
        <DropdownMenu as="ul" align="end">
          {links.map(this.renderLinkInMenuItem)}
        </DropdownMenu>
      </Dropdown>
    );
  }

  renderCommentForm(props) {
    if (!props.commenting && !props.input.value) {
      return <a href="#" onClick={this.handleRevealClick} styleName="reveal">Add a comment</a>;
    }

    return (
      <Fragment>
        <strong key="reveal" styleName="reveal">Comments</strong>
        <textarea key="input" {...props.input} className="form-control" styleName="comment" placeholder="Any related customer information" />
      </Fragment>
    );
  }


  renderComment() {
    const { commenting } = this.state;
    const { name } = this.props;
    const reduxKey = `comments[${name}]`;

    return (
      <Field
        name={reduxKey}
        component={this.renderCommentForm}
        commenting={commenting}
      />
    );
  }

  render() {
    const { name, prompt, help, children, links, comments } = this.props;

    return (  
      <div styleName="item">
        <h5 styleName="prompt">{prompt}</h5>
        {help && <p styleName="help">{help}</p>}
        {children}
        <div styleName="aligner">
          {links && this.renderLinks()}
          {comments && this.renderComment()}
        </div>
        <div styleName="separator" />
      </div>
    );
  }
}

QuestionnaireItem.defaultProps = {
  comments: true
};

QuestionnaireItem.propTypes = {
  name: PropTypes.string.isRequired,
  prompt: PropTypes.string.isRequired,
  help: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ]).isRequired,
  comments: PropTypes.bool.isRequired,
  links: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
  }))
};

export default QuestionnaireItem;
